
const dateFormat = require('bmh/date-format');
import { namespace } from 'vuex-class';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { Component, Vue } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
import SingleImageUpload from '@/component/single-image-upload.vue';
import { UPLOAD_DIR } from '@/constants';
import isImageSizeValid from '@/util/is-image-size-valid';
import { upload } from '@/util/oss';
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const Hundun = namespace('Hundun');
import client from 'baimahu/client';
const API = {
  get_reach_msg: `${FCAPI}/boss/hundun/work/temporary/user`,
  delete_tag: `${FCAPI}/boss/hundun/user/tag`,
  user_detail: `${FCAPI}/boss/hundun/user`,
  get_log: `${FCAPI}/boss/hundun/user/log`,
  edit_user_detail: `${FCAPI}/boss/hundun/user/attribute`,
  get_detail: `${FCAPI}/boss/hundun/company/`,
  get_collaborate: `${FCAPI}/boss/hundun/company/order`,
  add_collaborate: `${FCAPI}/boss/hundun/company/order`,
  get_relevance: `${FCAPI}/boss/hundun/company/relevance`,
  post_relevance: `${FCAPI}/boss/hundun/company/relevance`,
  serch_list: `${FCAPI}/boss/hundun/company`,
  delete_relevance: `${FCAPI}/boss/hundun/company/relevance`,
  log_list: `${FCAPI}/boss/hundun/company/log`,
  add_log: `${FCAPI}/boss/hundun/company/log`,
  get_follower_list: `${FCAPI}/boss/hundun/company/follower`,
  post_follower: `${FCAPI}/boss/hundun/company/followerrele`,
  delete_follower: `${FCAPI}/boss/hundun/company/followerrele/0`,
  edit_info: `${FCAPI}/boss/hundun/company`,
  user_list: `${FCAPI}/boss/hundun/user`,
  product_menu: `${FCAPI}/boss/setting/auth/product/menu`,
  oss: `${FCAPI}/boss/aliyun/oss/policy`,
  binding_student: `${FCAPI}/boss/hundun/company/user`
};

enum remarkType {
  company_remark,
  company_wiki
}

interface Preview {
  visible: boolean;
  url: string;
}

function validateMapFormat() {
  return {
    company_id: { value: '', status: '', help: '' },
    type: { value: undefined, status: '', help: '' },
    content: { value: '', status: '', help: '' },
    people_number: { value: '', status: '', help: '' },
    amount: { value: '', status: '', help: '' },
    start_time: { value: '', status: '', help: '' },
    end_time: { value: '', status: '', help: '' },
    is_invoice: { value: 0, status: '', help: '' },
    contract_transfer_image_list: { value: [], status: '', help: '' },
    remark: { value: '', status: '', help: '' }
  };
}

function relevanceMapFormat() {
  return {
    relevance_company_id: {
      value: '',
      status: '',
      help: ''
    },
    relation_type: {
      value: 1,
      status: '',
      help: ''
    }
  };
}

function getPreview(url: any = '', visible: any = false) {
  return {
    url,
    visible
  };
}

@Component({
  components: {
    SingleImageUpload,
    MultipleImageUpload
  }
})
export default class UserDetail extends Vue {
  user_table: any = {};
  table_detail: any = {};
  collaborate_list: any = {};
  relevance_list: any = {};
  collaborate_modal = false;
  relevance_modal = false;
  UPLOAD_DIR = UPLOAD_DIR;
  validate_map: any = validateMapFormat();
  relevance_map: any = relevanceMapFormat();
  collaborate_modal_is_edit = false;
  relevance_modal_is_edit = false;
  collaborate_type_format: any = { 1: '线上课程', 2: '线下课程', 3: '企业内训', 4: '其他' };
  collaborate_content_format: any = { '1': '大学籍', '2': 'API', '3': '创新力在线学员', '4': '创新训练营', '5': '创新商学院', '6': '创新第一课', '7': '创新必修课' };
  relation_type_format: any = { '1': '母公司', '-2': '子公司', '2': '总公司', '-3': '分公司', '4': '兄弟公司' };
  type_map = [
    { name: '无', id: 0 },
    { name: '国企', id: 1 },
    { name: '私企', id: 2 }
  ];
  cooperation_type_map = [
    { name: '请选择', id: -2 },
    { name: '暂无明确需求，持续跟进', id: 1 },
    { name: '待匹配合作方案', id: 2 },
    { name: '已出合作方案待回复', id: 4 },
    { name: '待签约', id: 5 },
    { name: '已合作', id: 3 }
  ];
  // 是否关键人
  is_keyman = [
    { id: 0, value: '否' },
    { id: 1, value: '是' },
    { id: 2, value: '不确定' }
  ];
  log_table: any = {};
  log_value = '';
  remark_value = '';
  amounts_num = { amount: 0 };
  preview: any = getPreview();
  add_student_visible = false;
  ref_show_tub = false;
  //是否兔必
  tob = [
    {
      id: 0,
      value: '否'
    },
    {
      id: 1,
      value: '是'
    },
    {
      id: 2,
      value: '不确定'
    }
  ];

  get is_tob_label() {
    let label = '';
    this.tob.some((tob) => {
      if (tob.id === this.table_detail.is_tob) {
        label = tob.value;
        return true;
      }
    });
    return label;
  }

  chooseTob() {
    this.ref_show_tub = true;
  }
  /* eslint-disable */
  // @ts-ignore
  @Hundun.State('tag_list') tag_list: any; //标签
  // @ts-ignore
  @Hundun.State('online_student_status') online_student_status: any; //线上学籍
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  // @ts-ignore
  @Hundun.State('offline_students_status') offline_students_status: any; //线下学籍
  // @ts-ignore
  @Hundun.State('identity') identity: any; //身份
  // @ts-ignore
  @Hundun.State('follow_status') follow_status: any; //跟进状态选项
  // @ts-ignore
  @Hundun.State('branch_office') branch_office: any; //分社
  // @ts-ignore
  @Hundun.State('cooperation_selects') cooperation_selects: any; //合作
  /* eslint-enable */
  get branch_widthout_all() {
    return this.branch_office.slice(1);
  }
  get teacher_widthout_all() {
    let s = [...this.teacher_list];
    s.pop();
    return s.slice(1);
  }
  get tag_without_all() {
    this.tag_list.pop();
    return this.tag_list;
  }
  get identity_without_all() {
    return [
      { id: 1, value: '领教' },
      { id: 2, value: '助教' },
      { id: 3, value: '辅导员' },
      { id: 4, value: '超级链接者' }
    ];
  }
  get follow_status_without_all() {
    return [
      { id: '1', value: '已加' },
      { id: '2', value: '团报' },
      { id: '3', value: '删' },
      { id: '4', value: '微信待通过' },
      { id: '5', value: '已发短信' },
      { id: '6', value: '微信非手机号' },
      { id: '7', value: '已电话沟通' },
      { id: '99', value: '其他' }
    ];
  }
  //企业类型
  corp_type = [
    { id: 1, value: '国企' },
    { id: 2, value: '私企' }
  ];
  // 企业规模
  corp_scale = [
    { id: 1, value: '0-50' },
    { id: 2, value: '50-100' },
    { id: 3, value: '100-500' },
    { id: 4, value: '500以上' }
  ];
  show_add_tag = false;
  tag_value = [];
  last_offline_status: any[] = []; //取消全部的线下
  last_cooperation_select: any[] = []; //去掉全部的合作
  is_loading = false;
  locale = zhCN;
  text_title = ''; //编写需求弹框标题
  form: any;
  add_student_form: any;
  user: any = {};
  modal_title = '';
  wechat_list: any[] = [];
  show_edit_modal = false;
  user_detail: any = {}; //用户详情
  user_id = 0;
  show_text_modal = false; //编写培训需求
  log = ''; //备注
  user_log = []; //跟进记录
  text = '';
  reach_msg = [];
  follower_list: any = [];
  remark_modal = false;
  remarkType = remarkType;
  enum_remark = remarkType.company_remark;
  company_wiki_val = '';
  company_remark_val = '';
  window = window as any;
  income: any = '';
  user_list_id = '';
  is_disabled = false;
  upload_file_list = [];
  logo_list = [] as any[];

  changeInputVal(val: any) {
    console.log(val);
  }

  //分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }

  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  add_tag() {
    this.tag_value = [];
    this.show_add_tag = true;
  }
  confirm_add() {
    const value = this.tag_value.pop();
    this.editDetail();
    this.show_add_tag = false;
  }
  editIntro(text: any) {
    this.text = text;
    this.text_title = '编辑公司简介';
    this.show_text_modal = true;
  }
  //确认编辑
  confirmEdit() {
    if (this.text_title === '编辑公司简介') {
      this.editDetail();
    } else {
      this.editDetail();
    }

    this.show_text_modal = false;
  }
  //编辑微信号
  editWechat() {
    this.modal_title = '微信号';
    this.show_edit_modal = true;
    this.wechat_list = [...this.user_detail.wechat];
  }
  // 编辑手机号
  editPhone() {
    this.modal_title = '关联手机号';
    this.show_edit_modal = true;
    this.wechat_list = [...this.user_detail.relation_mobile];
  }
  editTrain(text: any) {
    this.text_title = '编辑其他培训需求';
    this.text = text;
    this.show_text_modal = true;
  }
  //提交编辑
  editWechatAndPhone() {
    let send_data: any = [];
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        for (const key in values) {
          console.log(key);
          send_data.push(values[key]);
        }
        if (this.modal_title === '关联手机号') {
          this.editDetail();
        } else {
          this.editDetail();
        }
        this.show_edit_modal = false;
      } else {
        return;
      }
    });
  }
  //临时删除微信号
  deleteWechat(index: number) {
    this.wechat_list.splice(index, 1);
  }
  // 新增
  add() {
    this.wechat_list.push('');
  }
  //编辑回访时间
  async changeVisitTime(value: any) {
    const visit_time = value ? Math.floor((value as any).format('x') / 1000) : 0;
    const res: any = await this.$axios.put(`${API.get_detail}${this.$route.query.id}`, {
      callback_time: visit_time
    });
    if (res.data.status === 200) {
      this.$message.success('编辑成功');
    }
    // this.editDetail('visit_time', visit_time);
  }
  //获取用户详情
  async getUserDetail() {
    this.is_loading = true;
    const res: any = await this.$axios.get(`${API.user_detail}/${this.user_id}`);
    if (res.status === 200) {
      this.user_detail = res.data.data;
      let coopeartion = [];
      this.user_detail.cooperation ? coopeartion.push(this.user_detail.cooperation) : '';
      this.user_detail.cooperation_sub ? coopeartion.push(this.user_detail.cooperation_sub) : '';
      this.user_detail.cooperation = coopeartion;
      this.user_detail.visit_time = this.user_detail.visit_time === 0 ? '' : moment(this.user_detail.visit_time * 1000);
      this.user_detail.user_teacher = this.user_detail.user_teacher.map((item: any) => item.teacher_id);
      this.user_detail.corp_type = this.user_detail.corp_type === 0 ? '' : this.user_detail.corp_type;
      this.wechat_list = [...this.user_detail.wechat];
      // if (this.user_detail.offline_status[0] === '0') {
      //   this.user_detail.offline_status = [];
      // }
      if (this.user_detail.charge_teacher_id === 0) {
        this.user_detail.charge_teacher_id = '请选择';
      }
      if (this.user_detail.identity === 0) {
        this.user_detail.identity = '请选择';
      }
      if (this.user_detail.corp_scale === 0) {
        this.user_detail.corp_scale = '';
      }
      if (this.user_detail.branch_id === 0) {
        this.user_detail.branch_id = '';
      }
      if (this.user_detail.offline_status[0] === '0') {
        this.user_detail.offline_status = [];
      }

      this.is_loading = false;
    }
  }
  //精确到秒
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
  //精确到天
  dateFormat2(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d');
  }
  change() {
    console.log('11');
  }
  async getReachMsg() {
    this.is_loading = true;
    const res = await this.$axios.get(`${API.get_reach_msg}?user_id=${this.user_id}`);
    if (res.data.status === 200) {
      this.reach_msg = res.data.data;
      this.is_loading = false;
    }
    console.log(res);
  }
  //获取备注列表
  async getUserLog() {
    this.is_loading = true;
    const res: any = await this.$axios.get(`${API.get_log}?user_id=${this.user_id}`);
    this.user_log = res.data.data;
    this.is_loading = false;
  }
  //编辑属性
  async editDetail() {
    console.log(this.table_detail);
    // if (column === 'cooperation' && value.length === 1) {
    //   //合作如果是1级则二级放空
    //   value.push('');
    // }
    // if (column === 'corp_scale' && !value) {
    //   value = 0;
    // }
    // const send_data = {
    //   column: column,
    //   value: value,
    // };
    const visit_time = this.table_detail.callback_time ? Math.floor((this.table_detail.callback_time as any).format('x') / 1000) : 0;
    const income = this.income == null ? 0 : this.income * 10000;
    const res = await this.$axios.put(`${API.edit_info}/${this.$route.query.id}`, {
      ...this.table_detail,
      income: income,
      callback_time: visit_time,
      logo: this.logo_list.join(',')
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    // this.init();
    // if (column === 'charge_teacher_id' || column === 'teacher_id') {
    //   this.getUserLog();
    // }
    this.$message.success('编辑成功');
  }
  // 编辑属性
  async editUserDetail(id: any, keyman: any) {
    const res = await this.$axios.put(`${API.edit_user_detail}/${id}?menu_id=${this.window.route_menu_id}`, { column: 'is_keyman', value: keyman });
    this.$message.success('修改成功');
  }
  async editUserFollowerDetail(id: any, follower: any) {
    let send_data: any = [];
    follower.forEach((element: any) => send_data.push(this.follower_list.find((item: any) => item.id == element)));
    try {
      await this.$axios.put(`${API.edit_user_detail}/${id}?menu_id=${this.window.route_menu_id}`, {
        column: 'follower_json',
        value: send_data.map((element: any) => ({ id: element.id, name: element.weixin_nickname }))
      });
      this.$message.success('修改成功');
    } catch (error) {
      this.$message.error(error);
    }
  }
  async editUserRemarkDetail(id: any, column: any, value: any) {
    const res = await this.$axios.put(`${API.edit_user_detail}/${id}?menu_id=${this.window.route_menu_id}`, { column: column, value: value });
    this.$message.success('修改成功');
  }

  //翻页
  changeCollaboratePage(page: any) {
    this.initCollaborate(page.current);
  }

  //翻页
  changeUserPage(page: any) {
    this.initUser(page.current);
  }

  //翻页
  changeRelevancePage(page: any) {
    this.initRelevance(page.current);
  }

  handleConfirmTob() {
    this.ref_show_tub = false;
    this.editDetail();
  }

  //标签删除
  async deleteTag(id: number) {
    this.is_loading = true;
    const res: any = await this.$axios.delete(`${API.delete_tag}/${id}`);
    if (res.status == 200) {
      this.$message.success('删除成功');
      this.getUserDetail();
      return;
    }
    this.is_loading = false;
  }
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.add_student_form = this.$form.createForm(this);
  }

  async confirmEditCollaborate() {
    let is_valid = true;
    if (!this.validate_map.type.value) {
      this.validate_map.type.status = 'error';
      this.validate_map.type.help = '请选择合作类型';
      is_valid = false;
    }
    if (!this.validate_map.content.value) {
      this.validate_map.content.status = 'error';
      this.validate_map.content.help = '请填写合作情况';
      is_valid = false;
    }
    if (!this.validate_map.amount.value) {
      this.validate_map.amount.status = 'error';
      this.validate_map.amount.help = '请输入金额';
      is_valid = false;
    }
    if (!this.validate_map.start_time.value) {
      this.validate_map.start_time.status = 'error';
      this.validate_map.start_time.help = '请选择合作开始时间';
      is_valid = false;
    }
    if (!this.validate_map.end_time.value) {
      this.validate_map.end_time.status = 'error';
      this.validate_map.end_time.help = '请选择合作结束时间';
      is_valid = false;
    }
    if (!is_valid) {
      return;
    }
    this.is_disabled = true;
    const send_data = {
      company_id: ~~this.$route.query.id,
      type: this.validate_map.type.value,
      content: this.validate_map.content.value,
      people_number: this.validate_map.people_number.value,
      amount: this.validate_map.amount.value,
      start_time: this.validate_map.start_time.value.valueOf() / 1000,
      end_time: this.validate_map.end_time.value.valueOf() / 1000,
      is_invoice: this.validate_map.is_invoice.value,
      remark: this.validate_map.remark.value,
      contract_transfer_image_list: this.validate_map.contract_transfer_image_list.value
    };
    // console.log(this.validate_map.start_time.value.valueOf())
    const res: any = this.collaborate_modal_is_edit
      ? await this.$axios.put(`${API.add_collaborate}/${this.validate_map.id}`, send_data)
      : await this.$axios.post(API.add_collaborate, send_data);
    if (res.data.status === 200) {
      this.$message.success(this.collaborate_modal_is_edit ? '编辑成功' : '新增成功');
      this.initCollaborate();
      this.collaborate_modal = false;
    }
  }

  handleAddCollaborate() {
    this.validate_map = validateMapFormat();
    this.collaborate_modal_is_edit = false;
    this.collaborate_modal = true;
    this.is_disabled = false;
    console.log(this.table_detail);
  }

  handleEditCollaborate(item: any) {
    this.validate_map = {
      id: item.id,
      type: { value: item.type, status: '', help: '' },
      content: { value: item.content, status: '', help: '' },
      people_number: { value: item.people_number, status: '', help: '' },
      amount: { value: item.amount, status: '', help: '' },
      start_time: { value: moment(item.start_time * 1000), status: '', help: '' },
      end_time: { value: moment(item.end_time * 1000), status: '', help: '' },
      is_invoice: { value: item.is_invoice, status: '', help: '' },
      contract_transfer_image_list: { value: item.contract_transfer_image_list ? item.contract_transfer_image_list.split(',') : [], status: '', help: '' },
      remark: { value: item.remark, status: '', help: '' }
    };
    this.collaborate_modal_is_edit = true;
    this.collaborate_modal = true;
    this.is_disabled = false;
    console.log(this.validate_map);
  }

  handleAddRelevance() {
    this.relevance_map = relevanceMapFormat();
    this.relevance_modal = true;
    console.log(11);
  }

  handlePreview(url: string) {
    this.preview = getPreview(url, true);
  }

  handlePreviewCancel() {
    this.preview = getPreview();
  }

  async init() {
    console.log(this.$route.query.id);
    const res: any = await this.$axios.get(`${API.get_detail}${this.$route.query.id}`);
    if (res.data.data) {
      res.data.data.follower = res.data.data.follower.map((item: any) => item.follower_id);
      res.data.data.employees_number = res.data.data.employees_number ? res.data.data.employees_number : '';
    }
    if (res.data.status === 200) {
      res.data.data.callback_time = res.data.data.callback_time ? moment(res.data.data.callback_time * 1000) : '';
      this.table_detail = res.data.data;
      this.income = this.table_detail.income / 10000;
      this.logo_list = res.data.data.logo ? res.data.data.logo.split(',') : [];
    }
  }

  async initCollaborate(page = 1) {
    const send_data = {
      company_id: this.$route.query.id,
      current: page,
      limit: 5
    };
    const url = getUrl(API.get_collaborate, send_data);
    const res: any = await this.$axios.get(url);
    if (res.data.status === 200) {
      this.collaborate_list = res.data.data ? res.data.data : {};
      this.amounts_num = this.collaborate_list.detail.reduce(
        (pre: any, cuv: any) => {
          return {
            amount: ~~pre.amount + ~~cuv.amount
          };
        },
        {
          amount: '0'
        }
      );
      console.log(this.amounts_num);
    }
  }

  async initRelevance(page = 1) {
    const send_data = {
      company_id: this.$route.query.id,
      current: page,
      limit: 5
    };
    const url = getUrl(API.get_relevance, send_data);
    const res: any = await this.$axios.get(url);
    if (res.data.status === 200) {
      this.relevance_list = res.data.data ? res.data.data : {};
    }
    console.log('ressssssss', res);
  }

  async initLog() {
    const send_data = {
      company_id: this.$route.query.id,
      current: 1,
      limit: 999
    };
    const url = getUrl(API.log_list, send_data);
    const res: any = await this.$axios.get(url);
    if (res.data.status === 200) {
      this.log_table = res.data.data;
    }
  }

  beforeListImgUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    return isImageSizeValid(file, (width: number, height: number) => width === 670 && height === 313).catch((data: any) => {
      const { width, height } = data;
      this.$message.error(`图片宽高限定 670*313px，当前上传图片宽高为 ${width}*${height}`);
      return Promise.reject(null);
    });
  }

  async confirmEditRelevance() {
    let is_valid = true;
    if (!this.relevance_map.relevance_company_id.value) {
      this.relevance_map.relevance_company_id.status = 'error';
      this.relevance_map.relevance_company_id.help = '请输入全称';
      is_valid = false;
    }
    if (!is_valid) {
      return;
    }
    const send_data = {
      is_all: 0, //默认分页，传1表示不分页
      current: 1,
      is_export: 0, //是否导出
      limit: 10,
      full_name: this.relevance_map.relevance_company_id.value,
      location: '',
      industry: '',
      employees_number_floor: '',
      employees_number_ceil: '',
      cooperation_state: '',
      college: '',
      is_tob: '',
      remark: '',
      user_mobile: '',
      order_count: '',
      begin_start_time: [],
      finish_start_time: [],
      present_head_id: '',
      follow_up_content: ''
    };
    const url = getUrl(API.serch_list, send_data);
    const res: any = await this.$axios.get(url);
    if (!res.data?.data?.detail.length) {
      this.relevance_map.relevance_company_id.status = 'error';
      this.relevance_map.relevance_company_id.help = '企业不存在';
      return;
    }
    const res_post: any = await this.$axios.post(API.post_relevance, {
      company_id: this.$route.query.id,
      relevance_company_id: res.data.data.detail[0].id,
      relation_type: this.relevance_map.relation_type.value
    });

    if (res_post.data.status === 500) {
      // this.$message.error(res_post.data.message);
      return;
    }
    this.$message.success('关联成功');
    this.relevance_modal = false;
    this.initRelevance();
    console.log(11);
  }

  confirmEditInfo() {
    this.table_detail.wiki = this.company_wiki_val;
    this.table_detail.remark = this.company_remark_val;
    this.remark_modal = false;
    this.editDetail();
  }

  async handleDeleteRelevance(item: any) {
    const url = getUrl(`${API.delete_relevance}/${this.$route.query.id}`, {
      relevance_company_id: item.relevance_company_id
    });
    const res: any = await this.$axios.delete(url);
    if (res.data.status === 200) {
      this.$message.success('解除成功');
      this.initRelevance();
    }
  }

  //添加备注
  async addLog() {
    if (!this.log_value) {
      this.$message.error('请输入备注');
      return;
    }
    const send_data = {
      company_id: this.$route.query.id,
      content: `备注  “${this.log_value}”`
    };
    const res: any = await this.$axios.post(API.add_log, send_data);
    if (res.status == 200) {
      this.$message.success('提交成功');
      this.initLog();
    }
    this.log_value = '';
  }

  async initFollower() {
    const send_data = {
      current: 1,
      limit: 999999,
      weixin_nickname: '',
      mobile: '',
      charge: '',
      status: 0
    };
    const url = getUrl(API.get_follower_list, send_data);
    const res: any = await this.$axios.get(url);
    this.follower_list = res.data.data ? res.data.data.detail : [];
  }

  async handleEditFollower(value: any, record: any, is_delete: any = false) {
    const follower_name: any = this.follower_list.filter((item: any) => {
      return item.id === value;
    })[0];
    console.log(follower_name.weixin_nickname);
    const res: any = is_delete
      ? await this.$axios.delete(`${API.delete_follower}?company_id=${record.id}&follower_id=${value}`)
      : await this.$axios.post(API.post_follower, {
        company_id: record.id,
        follower_id: value,
        follower_name: follower_name.weixin_nickname
      });
    if (res.data.status === 200) this.$message.success('修改成功');
    else this.$message.error(res.data.message);
  }

  async initUser(page = 1) {
    const send_data = {
      current: page,
      limit: 5,
      company_id: this.$route.query.id,
      sort: 'keyman',
      show_log: 1
    };
    const url = getUrl(API.user_list, send_data);
    const res: any = await this.$axios.get(url);
    this.user_table = res.data.data ? res.data.data : [];
    if (this.user_table.detail) {
      this.user_table.detail.forEach((element: any) => (element.follower_json = element.follower_json ? JSON.parse(element.follower_json).map((item: any) => item.id) : []));
    }
  }

  handleJumpDetail(record: any) {
    this.$router.push({
      query: {
        id: record.company.id,
        name: record.company.full_name
      }
    });
    // this.$route.query.id = record.company.id;
    // this.$route.query.name = record.company.full_name;
    location.reload();
  }

  handleJumpUser(item: any) {
    this.$router.push({
      path: `/hundun/user-detail/${item.id}?menu_id=${this.user_list_id}`
    });
  }
  // menu_id更改
  async getMenuId() {
    const { data }: any = await client.get(`${API.product_menu}?product_code=hundun`);
    this.user_list_id = data.menu_list[1].id;
  }
  // 删除企业logo
  schemeFileClosed() {
    this.$message.success('删除成功!');
  }
  async upload(file: File) {
    const res = await upload(this.$axios, API.oss, file);
    if (res?.src) {
      this.logo_list.push(res.src);
      this.editDetail();
    }
    console.log(res?.src);
  }
  deleteIcon(index: number) {
    this.logo_list.splice(index, 1);
    this.editDetail();
  }
  // 添加企业logo
  beforeFileUpload(file: File) {
    this.upload(file);
    return false;
  }

  // 添加学员
  addStudent() {
    this.add_student_visible = true;
    console.log(this.add_student_form);
  }
  addStudentOk(e: any) {
    e.preventDefault();
    this.add_student_form.validateFields(async (err: any, values: any) => {
      const mobile: any = [];
      for (const val in values) {
        if (values[val]) mobile.push(values[val].replaceAll(/ /g, ''));
      }
      const send_data = {
        company_id: this.$route.query.id,
        mobile: mobile
      };
      const res: any = await this.$axios.post(API.binding_student, send_data);
      console.log(res);

      if (res.data.status !== 200) return this.$message.error(res.data.message);
      this.$message.success('编辑成功');
      this.add_student_form.resetFields();
      this.add_student_visible = false;
    });
  }
  addStudentCancel() {
    this.add_student_form.resetFields();
    this.add_student_visible = false;
  }
  created() {
    this.initCollaborate();
    this.initLog();
    this.initFollower();
    this.init();
    this.initUser();
    this.getMenuId();
    this.initRelevance();
  }
}
